import script from "./OperatorPaymnetChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorPaymnetChannel.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorPaymnetChannel.vue?vue&type=style&index=0&id=2e23f6b0&lang=scss"

const __exports__ = script;

export default __exports__